import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const DisplayService = () => {
    const [serviceName, setserviceName] = useState("");

    const handleDisplayService = async () => {
        try {
            const response = await fetch('https://apiroutetapxtream.invtechnologies.in/get_all_products', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                const data = await response.json();
                // console.log(data);
                setserviceName(data);
            } else {
                throw new Error('Failed to post data');
            }
        } catch (err) {
            console.error('Error getting data:', err);
        }
    };

    useEffect(() => {
        handleDisplayService();
    }, []);

    return (
        <Box sx={{
            p: 2,
            width: "320px",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            backgroundColor: "white",
            borderRadius: "10px"
        }}>
            {serviceName && (<Box>
                {serviceName.map((sn, index) => (
                    <Typography
                        key={index}
                        sx={{backgroundColor:"#34495e", borderRadius:"5px", color:"whitesmoke", p:1, m:1}}
                    >{index+1}. {sn.name}
                    </Typography>
                    
                ))}
            </Box>)}
        </Box>
    )
};
export default DisplayService;